import request from '@/request'
// 是否是工作人员
export const isWorker = data => {
  return request({
    url: '/inf_StaffUserinfo_Vipwd/isWorker.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 得到工作人员列表
export const getAssignList = data => {
  return request({
    url: '/inf_StaffUserinfo_Vipwd/getAssignList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 指派工作人员
export const assign = data => {
  return request({
    url: '/inf_StaffUserinfo_Vipwd/assign.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 得到用户信息列表
export const getUserList = data => {
  return request({
    url: '/inf_StaffUserinfo_Vipwd/getUserList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 申报小家信息
export const declare = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/declare.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

// 得到小家信息展示列表
export const getShowList = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/getShowList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getAreaType = data => {
  return request({
    url: '/mobile_SysDd/FTU_STAFF_AREATYPE.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 得到小家信息处理列表
export const getDealList = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/getDealList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 得到小家信息详情
export const getDetail = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/getDetail.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const modify = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/modify.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

// 得到小家流水
export const getFlow = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/getFlow.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 小家信息审核通过
export const verifyPass = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/verifyPass.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 小家信息审核拒绝
export const verifyRefuse = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/verifyRefuse.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 小家信息发布
export const publish = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/publish.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 小家信息下线
export const offline = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/offline.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 得到小家信息展示数量
export const getShowCount = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/getShowCount.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 删除指派工作人员信息
export const deleteList = data => {
  return request({
    url: '/inf_StaffUserinfo_Vipwd/delete.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 修改指派工作人员信息
export const modifyList = data => {
  return request({
    url: '/inf_StaffUserinfo_Vipwd/modify.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 得到小家展示信息详情
export const getShowDetail = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/getShowDetail.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getCountyShowCount = data => {
  return request({
    url: '/inf_StaffBaseinfo_Vipwd/getCountyShowCount.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 直播config
export const getZbConfig = data => {
  return request({
    url: '/exterior_intFtuZbConfig/getZbConfig.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 微医通config
export const getWYTConfig = data => {
  return request({
    url: '/exterior_intFtuWytConfig/getZbConfig.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const addZb = data => {
  return request({
    url: '/exterior_intFtuZbConfig/addZb.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
export const getZbAll = data => {
  return request({
    url: '/exterior_intFtuZbConfig/getZbAll.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
